import { render, staticRenderFns } from "./IconRewardShoppingCart.vue?vue&type=template&id=3d850e66"
import script from "./IconRewardShoppingCart.vue?vue&type=script&lang=js"
export * from "./IconRewardShoppingCart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports